import React from 'react';

function CatPlanet() {
  return (
    <div className="container mt-5">
      <h1 className="text-center mb-4">喵星净土</h1>
      <p className="text-center text-muted mb-5">纪念我们挚爱的已逝猫咪 • A Memorial for Our Beloved Cats</p>
      
      <div className="row">
        <div className="col-md-8 offset-md-2">
          <div className="card mb-4 border-0 shadow-sm">
            <div className="card-body text-center">
              <h5 className="card-title">永恒的爱与怀念</h5>
              <p className="card-text">
                "喵星净土"是一个特别的空间，用来纪念那些已经离开我们，前往彩虹桥的猫咪伙伴们。
                在这里，我们可以分享回忆，表达思念，并永远铭记它们带给我们的爱与欢乐。
                虽然它们不再与我们同行，但它们的爱和精神将永远活在我们心中。
              </p>
            </div>
          </div>
          
          <div className="card mb-4 border-0 shadow-sm">
            <div className="card-body">
              <h5 className="card-title text-center mb-4">纪念墙</h5>
              
              <div className="memorial-entry p-3 mb-4 bg-light rounded">
                <div className="d-flex align-items-center mb-3">
                  <div className="memorial-img-container me-3">
                    <div className="memorial-img-placeholder rounded-circle bg-secondary d-flex align-items-center justify-content-center" style={{width: '80px', height: '80px'}}>
                      <i className="bi bi-image text-white" style={{fontSize: '2rem'}}></i>
                    </div>
                  </div>
                  <div>
                    <h6 className="mb-0">小花 (Xiaohua)</h6>
                    <small className="text-muted">2010 - 2023</small>
                  </div>
                </div>
                <p>"小花是我生命中最忠实的伙伴，13年的陪伴让我明白了无条件的爱。她总是在我下班回家时等在门口，用她独特的叫声欢迎我。现在每当我推开家门，仍能感受到她的存在。愿她在彩虹桥的另一端安详快乐，直到我们再次相见。"</p>
                <small className="text-muted">— 李明, 2023年10月</small>
              </div>
              
              <div className="memorial-entry p-3 mb-4 bg-light rounded">
                <div className="d-flex align-items-center mb-3">
                  <div className="memorial-img-container me-3">
                    <div className="memorial-img-placeholder rounded-circle bg-secondary d-flex align-items-center justify-content-center" style={{width: '80px', height: '80px'}}>
                      <i className="bi bi-image text-white" style={{fontSize: '2rem'}}></i>
                    </div>
                  </div>
                  <div>
                    <h6 className="mb-0">胖虎 (Tiger)</h6>
                    <small className="text-muted">2015 - 2024</small>
                  </div>
                </div>
                <p>"胖虎，我的橘色大男孩，你带给我们家的欢笑无法计数。你对食物的热爱，对阳光的追逐，以及睡觉时发出的呼噜声，都是我最珍贵的回忆。虽然你离开了我们，但你在我们心中永远是那个贪吃又可爱的胖虎。"</p>
                <small className="text-muted">— 张家, 2024年2月</small>
              </div>
              
              <div className="text-center">
                <button className="btn btn-outline-secondary">查看更多纪念</button>
              </div>
            </div>
          </div>
          
          <div className="card mb-4 border-0 shadow-sm">
            <div className="card-body">
              <h5 className="card-title text-center">添加纪念</h5>
              <p className="card-text text-center">
                在这里分享您对已逝爱猫的思念与回忆，让它们的故事继续被传颂。
              </p>
              <div className="text-center">
                <button className="btn btn-primary">添加猫咪纪念</button>
              </div>
            </div>
          </div>
          
          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <h5 className="card-title text-center mb-4">慰藉之言</h5>
              <blockquote className="blockquote text-center">
                <p className="mb-0">"直到有一天，在彩虹桥的另一端，你们会再次相遇，共同奔跑。"</p>
                <footer className="blockquote-footer mt-2">彩虹桥诗篇</footer>
              </blockquote>
              
              <blockquote className="blockquote text-center mt-4">
                <p className="mb-0">"猫咪的生命虽短，但它们的爱却是永恒的。"</p>
              </blockquote>
              
              <blockquote className="blockquote text-center mt-4">
                <p className="mb-0">"它们的脚步声已经消失，但它们的脚印永远留在我们的心里。"</p>
              </blockquote>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CatPlanet;
